import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag, MapPin } from 'lucide-react';

export default function Discover() {
  useEffect(() => {
    document.title = 'Discover - Salt & Stone';
  }, []);

  return (
    <div className="min-h-screen bg-[#050505]" data-testid="discover-page">
      {/* Summer Sale Banner */}
      <div className="bg-gradient-to-r from-[#0A0A0A] via-[#1a1510] to-[#0A0A0A] border-y border-[#D4AF37]/20 pt-20">
        <div className="container mx-auto max-w-4xl py-4 px-6 text-center">
          <p className="text-[#D4AF37] text-sm tracking-[0.3em] uppercase">
            Summer Solstice — Limited Time Offering
          </p>
        </div>
      </div>

      {/* Hero Section */}
      <section className="relative min-h-[80vh] flex items-center justify-center overflow-hidden bg-black">
        {/* Background - Salt & Stone Bottle */}
        <div className="absolute inset-0">
          {/* Mobile/Tablet bottle - Top down style */}
          <div className="lg:hidden absolute left-1/2 -translate-x-1/2 top-0 -translate-y-[40%] h-[95vh] w-[90vw]">
            <img
              src="https://customer-assets.emergentagent.com/job_60caa5be-1d50-4b72-801b-3659f641dade/artifacts/9uzc6zo8_IMG_7292.jpg"
              alt="Salt & Stone Gin Bottle"
              className="h-full w-full object-contain opacity-40"
            />
            {/* Edge fade gradients */}
            <div className="absolute inset-0 pointer-events-none" style={{
              background: 'radial-gradient(ellipse 80% 70% at center 40%, transparent 45%, #000000 85%)'
            }}></div>
            <div className="absolute inset-0 pointer-events-none bg-gradient-to-b from-transparent via-transparent to-black"></div>
          </div>
          {/* Desktop bottle - Right side */}
          <img
            src="https://customer-assets.emergentagent.com/job_60caa5be-1d50-4b72-801b-3659f641dade/artifacts/9uzc6zo8_IMG_7292.jpg"
            alt="Salt & Stone Gin Bottle"
            className="hidden lg:block absolute right-0 top-1/2 -translate-y-1/2 h-full w-auto max-w-none object-contain opacity-80 translate-x-[10%]"
          />
          {/* Smooth blend gradients - Desktop only */}
          <div className="hidden lg:block absolute inset-0 bg-gradient-to-r from-[#050505] via-[#050505]/60 to-transparent"></div>
          <div className="hidden lg:block absolute inset-0 bg-gradient-to-b from-[#050505]/30 via-transparent to-[#050505]/80"></div>
          {/* Mobile/Tablet gradients */}
          <div className="lg:hidden absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-transparent"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
          <span className="caption block mb-6 animate-fade-in opacity-0" style={{ animationDelay: '0.2s', animationFillMode: 'forwards' }}>
            Cyprus Gin
          </span>
          <h1 className="font-['Playfair_Display'] text-4xl md:text-5xl lg:text-6xl text-[#F2F0E9] mb-6 animate-fade-in opacity-0" style={{ animationDelay: '0.4s', animationFillMode: 'forwards' }}>
            Discover Salt & Stone
          </h1>
          <p className="text-[#F2F0E9]/70 text-lg md:text-xl mb-12 max-w-2xl mx-auto animate-fade-in opacity-0" style={{ animationDelay: '0.6s', animationFillMode: 'forwards' }}>
            Experience the luxury of Cyprus in every sip
          </p>
          
          {/* Two Options */}
          <div className="flex flex-col sm:flex-row gap-6 justify-center animate-fade-in opacity-0" style={{ animationDelay: '0.8s', animationFillMode: 'forwards' }}>
            <Link 
              to="/shop" 
              className="btn-primary inline-flex items-center justify-center gap-3 px-12 py-4"
              data-testid="discover-shop-btn"
            >
              <ShoppingBag className="w-5 h-5" />
              Shop
            </Link>
            <Link 
              to="/find" 
              className="btn-secondary inline-flex items-center justify-center gap-3 px-12 py-4"
              data-testid="discover-find-btn"
            >
              <MapPin className="w-5 h-5" />
              Find Salt & Stone
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
